/**
 * Portée d'un profil (securite.profil.profil_portee). Un profil central voit toute la plateforme et
 * n'est rattaché à aucune commune ; un profil communal est limité au portail de sa commune.
 */
export enum ProfilPortee {
  CENTRAL = 'CENTRAL',
  COMMUNAL = 'COMMUNAL',
}

/** Codes des profils — un par « accès privilégié » du formulaire utilisateur. */
export enum ProfilCode {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN_FONCTIONNEL = 'ADMIN_FONCTIONNEL',
  LECTEUR_CENTRAL = 'LECTEUR_CENTRAL',
  ADMIN_TECHNIQUE_LOCAL = 'ADMIN_TECHNIQUE_LOCAL',
  ADMIN_COMMUNE = 'ADMIN_COMMUNE',
  AGENT_COMMUNE = 'AGENT_COMMUNE',
  LECTEUR_LOCAL = 'LECTEUR_LOCAL',
}

/** Profil servi par /api/profils (avec ses habilitations) ou embarqué dans un utilisateur. */
export interface Profil {
  '@id'?: string
  profilId: number
  profilRefCode: ProfilCode | string
  profilTitre: string
  profilPortee: ProfilPortee
  /** Codes des habilitations accordées (sans le préfixe ROLE_) ; servis par /api/profils seulement. */
  habilitations?: string[]
}

/** Habilitation servie par /api/habilitations. */
export interface Habilitation {
  '@id'?: string
  id: string
  habCode: string
  habType: string
  habDescription?: string | null
}
